(() => {
  if (customElements.get('cl-november-terms')) return;
  class NovemberTerms extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      const root = this.closest('cl-november'), dialog = this.querySelector('dialog');
      const viewport = this.closest('[data-nov-viewport]');
      root.addEventListener('click', event => {
        const trigger = event.target.closest('[data-nov-terms-open]');
        if (!trigger || dialog.open) return;
        this.trigger = trigger;
        this.previousOverflow = viewport.style.overflow;
        viewport.style.overflow = 'hidden';
        dialog.showModal();
        this.querySelector('.cl-nov-terms__content').scrollTop = 0;
        this.querySelector('[data-terms-close]').focus({ preventScroll: true });
      }, { signal });
      dialog.addEventListener('keydown', event => {
        // Let the native modal handle Tab/Escape; do not close its parent product panel.
        event.stopPropagation();
      }, { signal });
      dialog.addEventListener('click', event => {
        if (event.target.closest('[data-terms-close]')) dialog.close();
        else if (event.target === dialog) {
          const box = dialog.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
        }
      }, { signal });
      dialog.addEventListener('close', () => {
        viewport.style.overflow = this.previousOverflow || '';
        if (this.trigger?.isConnected) this.trigger.focus({ preventScroll: true });
      }, { signal });
    }
    disconnectedCallback() { this.controller?.abort(); }
  }
  customElements.define('cl-november-terms', NovemberTerms);
})();
